import React, { useEffect, useState } from 'react'
import seqStore from '../../store/seqStore'

export default function ChevronIcon({ sequenceMenuState }) {
    const currentTrack = seqStore((state) => state.settings.currentTrack)

    const [fillColour, setFillColour] = useState('#FFB72C')

    useEffect(() =>{
        switch(currentTrack) {
            case 0:
                setFillColour('#FFB72C')
                break
            case 1:
                setFillColour('#FC4B4B')
                break
            case 2:
                setFillColour('#47BE61')
                break
            case 3:
                setFillColour('#1A8DF8')
                break
            default: setFillColour('#FFB72C')
        }
    }, [currentTrack])

    return (
        <svg style={{ transform: sequenceMenuState ? 'rotate(180deg)' : 'rotate(0deg)' }} width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5383 1.22692C15.151 0.565151 16.1974 0.565149 16.8101 1.22692C17.3594 1.82033 17.3594 2.73663 16.8101 3.33004L10.2512 10.4147C9.45959 11.2698 8.10754 11.2698 7.31594 10.4147L0.757081 3.33004C0.207711 2.73663 0.207713 1.82034 0.757081 1.22692C1.36974 0.565151 2.41615 0.565152 3.0288 1.22692L8.78357 7.44304L14.5383 1.22692Z" fill={fillColour}/>
        </svg>
    )
}
